import { useCallback, useEffect, useState } from "react";

export function useApi<T>(
	fetcher: () => Promise<T>,
	deps: unknown[] = [],
	enabled = true,
) {
	const [data, setData] = useState<T | null>(null);
	const [error, setError] = useState<Error | null>(null);
	const [loading, setLoading] = useState(enabled);

	const reload = useCallback(async () => {
		if (!enabled) return;
		setLoading(true);
		setError(null);
		try {
			const result = await fetcher();
			setData(result);
		} catch (e) {
			setError(e instanceof Error ? e : new Error(String(e)));
		} finally {
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps.concat(enabled));

	useEffect(() => {
		if (!enabled) {
			setLoading(false);
			return;
		}
		void reload();
	}, [reload, enabled]);

	return { data, error, loading, reload };
}
